import styled from 'styled-components';

import { flexColumn, respondDown } from 'styles/mixins';
import { Breakpoints, COLORS } from 'styles/style-constants';

export const ApprovalCard = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 1.6rem;
    padding: 2.4rem;
    border-radius: 1.6rem;
    background: ${COLORS.gray50};
    ${respondDown(Breakpoints.md)`padding: 1.6rem; gap: 1.2rem;`};
`;
export const VaultIcon = styled.div`
    flex: 0 0 4rem;
    width: 4rem;
    height: 4rem;
    svg {
        display: block;
        width: 100%;
        height: 100%;
    }
`;
export const ApprovalText = styled.div`
    ${flexColumn};
    min-width: 0;
    gap: 0.8rem;
    font-size: 1.4rem;
    line-height: 2rem;
    color: ${COLORS.textGray};
    strong {
        color: ${COLORS.textPrimary};
        font-size: 1.6rem;
        font-weight: 500;
    }
`;
export const SignatureProgress = styled.div`
    display: flex;
    align-items: center;
    gap: 0.8rem;
    margin-top: 1.2rem;
    color: ${COLORS.textPrimary};
    svg {
        flex-shrink: 0;
        width: 2rem;
        height: 2rem;
    }
`;
export const Actions = styled.div`
    margin-top: 3.2rem;
`;
